import { InternalPermission } from 'src/constants/internal-access/internalPermissions'
import { ADMIN_ROUTES } from 'src/constants/routes'
import type { PaymentsOpsNavItem, PaymentsOpsNavSection } from './paymentsOpsNav.types'

/** The three groups mirror the three Linear issues and the prototype's rail order. */
export const PAYMENTS_OPS_SECTIONS: PaymentsOpsNavSection[] = [
  {
    label: 'Review & approve',
    items: [
      {
        slug: 'payments-review',
        to: ADMIN_ROUTES.PAYMENTS_OPS_PAYMENTS_REVIEW_URL,
        label: 'Payments Review',
        issueId: 'ENG-491',
        iconName: 'gs_circle_check',
        requiredAnyPermission: [InternalPermission.PaymentsReviewView],
      },
      {
        slug: 'incoming-transactions',
        to: ADMIN_ROUTES.PAYMENTS_OPS_INCOMING_TRANSACTIONS_URL,
        label: 'Incoming Transactions',
        issueId: 'ENG-491',
        iconName: 'gs_coins_add',
        requiredAnyPermission: [InternalPermission.TransactionsReviewView],
      },
      {
        slug: 'outgoing-transactions',
        to: ADMIN_ROUTES.PAYMENTS_OPS_OUTGOING_TRANSACTIONS_URL,
        label: 'Outgoing Transactions',
        issueId: 'ENG-491',
        iconName: 'gs_paper_plane_top_right',
        requiredAnyPermission: [InternalPermission.TransactionsReviewView],
      },
      {
        slug: 'refunds',
        to: ADMIN_ROUTES.PAYMENTS_OPS_REFUNDS_URL,
        label: 'Refunds',
        issueId: 'ENG-491',
        iconName: 'gs_arrows_repeat_right_left',
        requiredAnyPermission: [InternalPermission.RefundsView],
      },
    ],
  },
  {
    label: 'Onboarding & ledger',
    items: [
      {
        slug: 'bank-onboarding',
        to: ADMIN_ROUTES.PAYMENTS_OPS_BANK_ONBOARDING_URL,
        label: 'Bank Onboarding',
        issueId: 'ENG-492',
        iconName: 'gs_bank',
        requiredAnyPermission: [InternalPermission.BankOnboardingView],
      },
      {
        slug: 'us-bank-transactions',
        to: ADMIN_ROUTES.PAYMENTS_OPS_US_BANK_TRANSACTIONS_URL,
        label: 'US Bank Transactions',
        issueId: 'ENG-492',
        iconName: 'gs_receipt_bill',
        requiredAnyPermission: [InternalPermission.UsBankTransactionsView],
      },
      {
        slug: 'wallets',
        to: ADMIN_ROUTES.PAYMENTS_OPS_WALLETS_URL,
        label: 'Wallets',
        issueId: 'ENG-492',
        iconName: 'gs_wallet_3',
        requiredAnyPermission: [InternalPermission.WalletsView],
      },
      {
        slug: 'fees-withdraw-reports',
        to: ADMIN_ROUTES.PAYMENTS_OPS_FEES_WITHDRAW_REPORTS_URL,
        label: 'Fees Withdraw Reports',
        issueId: 'ENG-1212',
        iconName: 'gs_file_download',
        requiredAnyPermission: [InternalPermission.FeeWithdrawalsView],
      },
    ],
  },
  {
    label: 'Controls',
    items: [
      {
        slug: 'reconciliation',
        to: ADMIN_ROUTES.PAYMENTS_OPS_RECONCILIATION_URL,
        label: 'Reconciliation',
        issueId: 'ENG-493',
        iconName: 'gs_arrows_repeat',
        requiredAnyPermission: [InternalPermission.ReconciliationRun],
      },
      {
        slug: 'killswitch',
        to: ADMIN_ROUTES.PAYMENTS_OPS_KILLSWITCH_URL,
        label: 'Killswitch',
        issueId: 'ENG-493',
        iconName: 'gs_lightning_bolt',
        // Switch state is a feature-flag GET; captured events are their own permission.
        requiredAnyPermission: [
          InternalPermission.FeatureFlagsView,
          InternalPermission.UsBankKillswitchManage,
        ],
      },
    ],
  },
]

export const PAYMENTS_OPS_ITEMS: PaymentsOpsNavItem[] = PAYMENTS_OPS_SECTIONS.flatMap((section) => {
  return section.items
})
